import defaultSource from "./defaultSource.js";
export default (function sourceRandomExponential(source) {
    function randomExponential(lambda) {
        return function () {
            return -Math.log1p(-source()) / lambda;
        };
    }
    randomExponential.source = sourceRandomExponential;
    return randomExponential;
})(defaultSource);
